(() => {
/**
 * Add custom styles to Heading block.
 */ const $58c5c39e3b1aa903$var$HeadingOverrides = ()=>{
    wp.blocks.registerBlockStyle("core/heading", {
        name: "default",
        label: "Default",
        isDefault: true
    });
    wp.blocks.registerBlockStyle("core/heading", {
        name: "outline",
        label: "Outline"
    });
};
var $58c5c39e3b1aa903$export$2e2bcd8739ae039 = $58c5c39e3b1aa903$var$HeadingOverrides;


(0, $58c5c39e3b1aa903$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=editor.js.map
